import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';



import { environment } from 'src/environments/environment';
import { ApplicationConfigService } from '../app-config-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private applicationConfigService: ApplicationConfigService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverApiUrl = this.applicationConfigService.getEndpointFor('');
    if (!request.url || (request.url.startsWith('http') && !(serverApiUrl && request.url.startsWith(serverApiUrl)))) {
      return next.handle(request);
    }

      request = request.clone({
        setHeaders: {
          'X-TenantID': environment.tenant,
          'X-Client-Offset': new Date().getTimezoneOffset().toString()
        },
      });
    
    return next.handle(request);
  }
}
